import { render, staticRenderFns } from "./QuickstartGuide.vue?vue&type=template&id=120f307e&lang=pug"
import script from "./QuickstartGuide.vue?vue&type=script&lang=js"
export * from "./QuickstartGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports